export class ResourceModel {
    Name: string;
    DutchValue: string;
    EnglishValue: string;
    FrenchValue: string;
}

export enum ResourceModelName {
    Email = 'AgCustomerCareEmailAddress',
    Signature = 'AgCustomerCareEmailSignature'
}
